module.exports = __webpack_public_path__ + "img/hc_pro_night_2.46517eab.jpg";